import React, { Suspense, useContext } from "react";
import { Box } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import A_Home from "./pages/Admin/A_Home";
import StaffForm from "./pages/Teacher/T_Add";
import StudentForm from "./pages/Student/S_Add";
import StudentTable from "./pages/Student/S_Details";
import ParentList from "./pages/Parent/P_List";
import Class from "./pages/Class/Class";
import ClassList from "./pages/Class/Individual/ClassList";
import ClassPage from "./pages/Class/Class_Page";
import TimeTable from "./pages/Class/Timetable";
import Subject from "./pages/Subject/Subject";
import StudentDetails from "./pages/Student/Student_detail/Student_details";
import Exam_details from "./pages/Exam/Exam_details";
import Exam_Result from "./pages/Exam/Exam_Reesult";
import Grade from "./pages/Exam/Grade";
import Add_Marks from "./pages/Teacher/Add_Student_Mark";
import TeacherTable from "./pages/Teacher/T_Details";
import { LocationProvider } from "./Context/LocationProvider";
import { StudentProvider } from "./Context/StudentContext";
import { TeacherProvider } from "./Context/TeacherContext";
import Assigning_subject from "./pages/Subject/Assigning_subject";
import Upload from "./pages/Material/Upload";
import View_Material from "./pages/Material/View_Material";
import Staff_Material from "./pages/Material/Staff_View";
import Student_view from "./pages/Material/Student_view";
import Student_timetable from "./pages/Class/Student_timetable";
import Staff_timetable from "./pages/Class/Staff_timetable";
import StaffDetails from "./pages/Teacher/Staff_details";
import Student_Result from "./pages/Exam/Student_result";
import Classteacher_Result from "./pages/Exam/ClassTeacher_result";
import Parent_Result from "./pages/Exam/Parent_Result";
import Sub_Result from "./pages/Exam/Subtr_result";
import Login from "./pages/Login/Login";
import RolePermissionAssignment from "./pages/Permission/Permission";
import ProtectedRoute from "./pages/Login/ProtectedRoute";
import ProfileCard from "./pages/Teacher/Dashboard";
import AdminDashboard from "./pages/Admin/Dashboard";
import Subject_Class from "./pages/Class/Subject_Class";
import Class_List from "./pages/Teacher/Class";
import Dashboard from "./pages/Student/Dashboard";
import { AuthProvider, AuthContext } from "./components/Auth/AuthContext";
import TransferCertificate from "./pages/Student/Student_detail/Transfer";
import Profilestaff from "./pages/Teacher/Profile";
import DashboardParent from "./pages/Parent/Dashboard";
import ViewCertificate from "./pages/Student/Student_detail/ViewTC";
import Create_student from "./pages/Teacher/Create_student";
import ProfilePage from "./pages/Profile/ProfilePage";
import Admin_staff_tt from "./pages/Class/Admin_staff_tt";
import Exam from "./pages/Student/Exam";
import About from "./pages/About/About";
import Webpannel from "./pages/Webpannel/Webpannel";
// import HouseAssigning from "./pages/Test/Test";
import { useDrag, useDrop, DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ClassTimetable from "./pages/Class/Class_timetable";
import Individual_Notice from "./pages/Announcement/Notice/Individual_Notice";
import Notice from "./pages/Announcement/Notice/Notice";
// import Event from "./pages/Event/Event_Create_View/Event";
// import Individual_Events from "./pages/Announcement/Event/Individual_Event";
import Enquiry from "./pages/Announcement/Enquiry/Enquiry";
import Message from "./pages/Announcement/Message/Message";
import ClassTest from "./pages/ReportCard/ClassTest/ClassTest";
import AnnualReport from "./pages/ReportCard/AnnualReport/AnnualReport";
import ModelTest from "./pages/ReportCard/ModelTest/ModelTest";
import Homework from "./pages/Material/Homework";
import View_Homework from "./pages/Material/View_Homework";
import Student_Homework from "./pages/Material/Student_Homework";
import HouseCreation from "./pages/School House/HouseCreation";
import HouseAssigning from "./pages/School House/HouseAssigning";
import TeacherHouse from "./pages/School House/TeacherHouse";
import Forgotpass from "./pages/Login/Forgotpass";
// import OtpInput from "./pages/Login/OtpInput";
import GuardianDetails from "./pages/Parent/View";
import Individual_class from "./pages/Class/Individual/Individual_class";
import AdmissionEnquiry from "./pages/Student/Admission/AdmissionEnquiry";
import Bus_Create_form from "./pages/Bus/BusCreation/Bus_Create_form";
import Bus_details from "./pages/Bus/BusDetails/Bus_details";
import Allocate_details from "./pages/Bus/Student_Assign/Allocate_details";
import Event from "./pages/Event/Event_Create_View/Event";
import Individual_Events from "./pages/Event/Event_Create_View/Individual_Event";
import Registration from "./pages/Event/Event_Reg_Form/Registration";
import Cat_Sub_Cat_Create from "./pages/Event/Allocated_Tr_Side/Cat_Sub_Cat_Create";
import Single_tr_Main_Page from "./pages/Event/Single_Teacher/Single_tr_Main_Page";
import Staff_Bus_details from "./pages/Bus/BusDetails/Staff_details";
import Library from "./pages/Library/Main_Page/Library";
import Issue_main from "./pages/Library/allocated_Teacher/IssueBook/Issue_main";
import Return_main from "./pages/Library/allocated_Teacher/ReturnBook/Return_main";
import Student_Register from "./pages/Event/Allocated_Tr_Side/Student_Register";
import Main_Result from "./pages/Event/Single_Teacher/Main_Result";
import StudentsRegister from "./pages/Event/Allocated_Tr_Side/Students_Register";
import Class_tr_bus_students from "./pages/Bus/Class_tr_bus_students/Class_tr_bus_students";
// import Division from "./pages/Class/Individual/Division";
import School_create from "./pages/Admin/School_create";
import SchoolCreate from "./pages/Admin/School_create";
import Library_Book_Return from "./pages/Library/Profile_student_library/Library_Book_Return";
import Library_Staff_Return from "./pages/Library/Profile_Teacher/Library_staff";
import Main_Member from "./pages/Library/Membership/Main_Member";
import Fees_Group from "./pages/Fees/Fees_Group/Fees_Group";
import MasterTable from "./pages/Fees/Fees_Master/Master_Table";
import Fee_report from "./pages/Fees/Fees_Collection/Collection";
import Gsummary from "./pages/Accounts/Reports/GSummary/Gsummary";
import LandP from "./pages/Accounts/Reports/LossandProfit/LoassandProfit";
import BalanceSheet from "./pages/Accounts/Reports/Balancesheet/BalanceSheet";
import DayBook from "./pages/Accounts/Reports/DayBook/DayBook";
import PAssBook from "./pages/Accounts/Reports/PassBook/PAssBook";
import CashBook from "./pages/Accounts/Reports/CashBook/CashBook";
import Ledger from "./pages/Accounts/Reports/Ledger/Ledger";
import TrialBalance from "./pages/Accounts/Reports/TrialBalance/TrialBalance";
import Edit from "./pages/Accounts/Reports/CreateLedger/Edit";
import GsummaryTwo from "./pages/Accounts/Reports/GSummary/Gsummary2";
import GsummaryThree from "./pages/Accounts/Reports/GSummary/Gsummary3";
import CreateLedger from "./pages/Accounts/Reports/CreateLedger/CreateLedger";
import Customer from "./pages/Accounts/Party/Customer/Customer";
import CustomerEdit from "./pages/Accounts/Party/Customer/CustomerEdit";
import MUltientry from "./pages/Accounts/Vouchers/Multientry/Multientry";
import MEList from "./pages/Accounts/Vouchers/MeList/MEList";
import MEEdit from "./pages/Accounts/Vouchers/MeList/MEEdit";
import View from "./pages/Accounts/Vouchers/Asset/View";
import Views from "./pages/Accounts/Vouchers/Income/View";
import Viewe from "./pages/Accounts/Vouchers/Expenses/View";
import Paymentv from "./pages/Accounts/Vouchers/Payment/Paymentv";
import ViewP from "./pages/Accounts/Vouchers/Payment/ViewP";
import ViewW from "./pages/Accounts/Vouchers/Withdrawal/ViewW";
import Withdrawal from "./pages/Accounts/Vouchers/Withdrawal/Withdrawal";
import ViewD from "./pages/Accounts/Vouchers/Deposit/ViewD";
import Deposit from "./pages/Accounts/Vouchers/Deposit/Deposit";
import Income from "./pages/Accounts/Vouchers/Income/Income";
import Expense from "./pages/Accounts/Vouchers/Expenses/Expense";
import Liability from "./pages/Accounts/Vouchers/Liability/Liability";
import Assets from "./pages/Accounts/Vouchers/Asset/Assets";
import LiabilityAdd from "./pages/Accounts/Vouchers/Liability/LiabilityAdd";
import Student_profile from "./pages/Profile/Student/Student_profile";
import Paid_list from "./pages/Fees/Student_Paid_list/Paid";
import Fee_list from "./pages/Fees/Guardian_fee_list/Fee_list";
import Student_fee_table from "./pages/Bus/Bus_fee/Student_fee_table";
import Main_fee_table from "./pages/Bus/Bus_fee/Main_fee_table";
import Teacher_sidebar_Table from "./pages/Bus/TeacherBusFee/Teacher_sidebar_Table";
import Busfee_Guardian_Sidebar from "./pages/Bus/Bus_Guardian_side/Busfee_Guardian_Sidebar";
import Guardian_side_library from "./pages/Library/Guardian/Guardian_side_library";
import Teacher_profile from "./pages/Profile/Teacher/Teacher_profile";
import Return_Table from "./pages/Library/allocated_Teacher/ReturnBook/Return_Table";
import Result_admin_view from "./pages/Event/Event_Create_View/Result_admin_view";
import TabsTeacher from "./pages/School House/TabsTeacher";
import Promotion from "./pages/Promotion/Promotion";
import Create from "./pages/AcademicYear/MainFolder/MainFileYear";
import MainFileYear from "./pages/AcademicYear/MainFolder/MainFileYear";
import AddGuardian from "./pages/Student/Student_detail/AddGuardian";
import Exam_Category from "./pages/Exam/Exam_Category";
import Attendance from "./pages/Student/Attendance";

const Sidebar = React.lazy(() => import("./components/layout/Sidebar"));

function App() {
  const { isAuthenticated, userType } = useContext(AuthContext);
  const location = useLocation();

  const isLoginPage = location.pathname === "/login";

  return (
    <Box className="App">
      {!isLoginPage && (
        // <Suspense fallback={<div>Loading...</div>}>
        <Sidebar />
        // {/* </Suspense> */}
      )}
      <Box
        ml={isLoginPage ? 0 : { base: 0, md: 60 }}
        // p="4"
        // flex="1"
        // display="flex"
        flexDirection="column"
      >
        <Routes>
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate
                  to={
                    userType === "1"
                      ? "/admin"
                      : userType === "2"
                      ? "/staff"
                      : userType === "3"
                      ? "/student"
                      : userType === "4"
                      ? "/guardian"
                      : "/login"
                  }
                />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          {/* Authenticated Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route
            path="/teachers/add"
            element={
              <LocationProvider>
                <TeacherProvider>
                  <StaffForm />
                </TeacherProvider>
              </LocationProvider>
            }
          />
          <Route
            path="/teachers/all"
            element={
              <LocationProvider>
                <TeacherProvider>
                  <TeacherTable />
                </TeacherProvider>
              </LocationProvider>
            }
          />
          <Route
            path="/students/add"
            element={
              <LocationProvider>
                <StudentProvider>
                  <StudentForm />
                </StudentProvider>
              </LocationProvider>
            }
          />
          <Route
            path="/guardians/add"
            element={
              <LocationProvider>
                <AddGuardian />
              </LocationProvider>
            }
          />
          <Route
            path="/students/all"
            element={
              <LocationProvider>
                <StudentProvider>
                  <StudentTable />
                </StudentProvider>
              </LocationProvider>
            }
          />
          <Route path="/guardian" element={<DashboardParent />} />
          <Route
            path="/class/list"
            element={
              <TeacherProvider>
                <Class />
              </TeacherProvider>
            }
          />
          <Route
            path="/class/:classId"
            element={
              <StudentProvider>
                <TeacherProvider>
                  <ClassPage />
                </TeacherProvider>
              </StudentProvider>
            }
          />
          <Route path="/timetable/create" element={<TimeTable />} />
          <Route path="/class/classlist" element={<ClassList />} />
          <Route path="/attendance" element={<Attendance />} />

          <Route
            path="/timetable/student_view"
            element={<Student_timetable />}
          />
          <Route path="/timetable/view" element={<Admin_staff_tt />} />

          <Route
            path="/timetable/staff_view"
            element={
              <ProtectedRoute allowedRoles={["2"]}>
                <Staff_timetable />
              </ProtectedRoute>
            }
          />
          <Route path="/teachers/detail/:user_id" element={<StaffDetails />} />
          <Route path="/material/upload" element={<Upload />} />
          <Route path="/material/view" element={<View_Material />} />
          <Route
            path="/material/staff_view"
            element={
              <ProtectedRoute allowedRoles={["2"]}>
                <Staff_Material />
              </ProtectedRoute>
            }
          />
          <Route path="/material/student_view" element={<Student_view />} />
          <Route path="/subject" element={<Subject />} />
          <Route path="/subject_teacher" element={<Assigning_subject />} />
          <Route path="/subject_class" element={<Subject_Class />} />
          <Route path="/classlist" element={<Class_List />} />
          <Route
            path="/students/detail/:user_id"
            element={<StudentDetails />}
          />
          <Route path="/exam/detail" element={<Exam_details />} />
          <Route path="/exam/result" element={<Exam_Result />} />
          <Route path="/exam/grade" element={<Grade />} />
          <Route path="/exam/student/result" element={<Student_Result />} />
          <Route path="/exam/student/exam" element={<Exam />} />
          <Route path="/exam/category" element={<Exam_Category />} />

          <Route
            path="/student/admission/enquiry"
            element={<AdmissionEnquiry />}
          />

          <Route
            path="/exam/classteacher/result"
            element={<Classteacher_Result />}
          />
          <Route path="/exam/parent/result" element={<Parent_Result />} />
          <Route path="/exam/subject/result" element={<Sub_Result />} />
          <Route path="/students/create" element={<Create_student />} />
          <Route path="/permission" element={<RolePermissionAssignment />} />
          <Route
            path="/staff"
            element={
              <ProtectedRoute allowedRoles={["2"]}>
                <ProfileCard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/teachers/add_mark"
            element={
              <TeacherProvider>
                <Add_Marks />
              </TeacherProvider>
            }
          />

          <Route path="/profile" element={<Profilestaff />} />
          <Route path="/about" element={<About />} />
          <Route path="/Webpannel" element={<Webpannel />} />

          <Route path="/transfer" element={<TransferCertificate />} />
          <Route path="/viewtransfer/:tc_id" element={<ViewCertificate />} />

          <Route path="/profile/individual" element={<Student_profile />} />
          <Route
            path="/profile/staff/individual"
            element={<Teacher_profile />}
          />
          <Route path="/timetable/class" element={<ClassTimetable />} />

          <Route
            path="/test"
            element={
              <DndProvider backend={HTML5Backend}>
                <HouseAssigning />
              </DndProvider>
            }
          />

          <Route
            path="/class/individual/class/:classId"
            element={<Individual_class />}
          />
          {/* <Route path="/division/class_master" element={<Division />} /> */}

          <Route path="/announcement/notice" element={<Notice />} />
          <Route
            path="/announcement/individual/notice"
            element={<Individual_Notice />}
          />
          <Route path="/event/admin/rewards" element={<Result_admin_view />} />
          <Route
            path="/announcement/individual/event"
            element={<Individual_Events />}
          />
          <Route path="/Event/create" element={<Event />} />
          <Route path="/event/registration" element={<Registration />} />
          <Route
            path="/event/category_sub_category_create"
            element={<Cat_Sub_Cat_Create />}
          />

          <Route
            path="/event/student_registered"
            element={<StudentsRegister />}
          />
          <Route path="/event/student_rewards" element={<Main_Result />} />

          <Route
            path="/event/single_teacher_view"
            element={<Single_tr_Main_Page />}
          />
          <Route path="/library/create" element={<Library />} />

          <Route path="/library/issue" element={<Issue_main />} />
          <Route path="/library/return" element={<Return_main />} />

          <Route
            path="/staff/library_return_book_list"
            element={<Return_Table />}
          />
          <Route path="/promotion" element={<Promotion />} />

          <Route path="/announcement/enquiry" element={<Enquiry />} />
          <Route path="/announcement/message" element={<Message />} />

          <Route path="/report/ClassTest" element={<ClassTest />} />
          <Route path="/report/AnnualReport" element={<AnnualReport />} />
          <Route path="/report/ModelTest" element={<ModelTest />} />

          <Route path="/material/homework" element={<Homework />} />
          <Route
            path="/material/view_student_homework"
            element={<Student_Homework />}
          />
          <Route path="/material/view_homework" element={<View_Homework />} />

          <Route path="/house/student_house_list" element={<HouseCreation />} />
          <Route path="/house/tr_house_list" element={<TeacherHouse />} />

          <Route path="/house/assigning" element={<HouseAssigning />} />

          <Route path="/create_school" element={<SchoolCreate />} />
          <Route path="/academic_year" element={<MainFileYear />} />

          <Route
            path="/student/library_return_book"
            element={<Library_Book_Return />}
          />

          <Route
            path="/staff/library_return_book"
            element={<Library_Staff_Return />}
          />
          <Route
            path="/library/return/guardian"
            element={<Guardian_side_library />}
          />

          <Route path="/bus/bus_details" element={<Bus_details />} />
          <Route
            path="/bus/allocate_students/:id"
            element={<Allocate_details />}
          />
          <Route
            path="/bus/staff_bus_details"
            element={<Staff_Bus_details />}
          />

          <Route
            path="/bus/class_student_bus_details"
            element={<Class_tr_bus_students />}
          />
          <Route
            path="/bus/fee/student/fee_list"
            element={<Student_fee_table />}
          />
          <Route
            path="/bus/fee/student_teachers/fee_list"
            element={<Main_fee_table />}
          />
          <Route
            path="/bus/fee/tecaher/fee_list"
            element={<Teacher_sidebar_Table />}
          />
          <Route
            path="/bus/fee/guardian/student_busfee_list"
            element={<Busfee_Guardian_Sidebar />}
          />

          <Route path="/library/membership" element={<Main_Member />} />

          <Route path="/fees/type" element={<Fees_Group />} />
          <Route path="/fees/master" element={<MasterTable />} />
          <Route path="/fees/report" element={<Fee_report />} />
          <Route path="/fees/paid" element={<Paid_list />} />
          <Route path="/fees/fee" element={<Fee_list />} />

          <Route path="/accounts/create_ledger" element={<CreateLedger />} />
          <Route path="/accounts/create_ledger/edit" element={<Edit />} />
          <Route path="/accounts/day_book" element={<DayBook />} />
          <Route path="/accounts/pass_book" element={<PAssBook />} />
          <Route path="/accounts/cash_book" element={<CashBook />} />
          <Route path="/accounts/ledger_report" element={<Ledger />} />
          <Route path="/accounts/trial_balance" element={<TrialBalance />} />
          <Route path="/accounts/g_summary" element={<Gsummary />} />
          <Route path="/accounts/g_summary/two" element={<GsummaryTwo />} />
          <Route path="/accounts/g_summary/three" element={<GsummaryThree />} />
          <Route path="/accounts/p&l" element={<LandP />} />
          <Route path="/accounts/balance_sheet" element={<BalanceSheet />} />

          <Route path="/party/customer" element={<Customer />} />
          <Route path="/party/customer/edit" element={<CustomerEdit />} />

          <Route path="/voucher/income" element={<Income />} />
          <Route path="/voucher/income/add" element={<Views />} />
          <Route path="/voucher/expense" element={<Expense />} />
          <Route path="/voucher/expense/add" element={<Viewe />} />
          <Route path="/voucher/liability" element={<Liability />} />
          <Route path="/voucher/liability/add" element={<LiabilityAdd />} />
          <Route path="/voucher/asset/add" element={<View />} />
          <Route path="/voucher/multientry" element={<MUltientry />} />
          <Route path="/voucher/multientry/view" element={<MEList />} />
          <Route
            path="/voucher/multientry/edit/:voucherNo"
            element={<MEEdit />}
          />
          <Route path="/voucher/payment" element={<Paymentv />} />
          <Route path="/voucher/payment/add" element={<ViewP />} />
          <Route path="/voucher/withdrawal" element={<Withdrawal />} />
          <Route path="/voucher/withdrawal/add" element={<ViewW />} />
          <Route path="/voucher/deposit" element={<Deposit />} />
          <Route path="/voucher/deposit/add" element={<ViewD />} />
          <Route path="/voucher/assets" element={<Assets />} />

          <Route path="/forgot_pass" element={<Forgotpass />} />
          {/* <Route path="/otp" element={<OtpInput />} /> */}

          <Route path="/guardian/view/:id" element={<GuardianDetails />} />

          <Route path="/student" element={<Dashboard />} />
          <Route path="/guardian/list" element={<ParentList />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="*"
            element={
              <Navigate
                to={
                  isAuthenticated
                    ? `/${
                        userType === "1"
                          ? "admin"
                          : userType === "2"
                          ? "staff"
                          : userType === "3"
                          ? "student"
                          : "guardian"
                      }`
                    : "/login"
                }
              />
            }
          />
        </Routes>
      </Box>
    </Box>
  );
}

export default App;
